var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm._client.client_name)?_c('div',[(_vm._client.client_name !== 'shark')?_c('reports'):_c('shark-reports')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }